import React from 'react';
import { Link } from 'react-router-dom';
import { UserButton, useAuth } from '@clerk/clerk-react';
import { ChevronDown, User, Users, LogOut, Settings as SettingsIcon } from 'lucide-react';
import { recurringValuePodcastLogoUrl } from '../assets'; // Import the logo URL
import { useAuthContext } from '@/features-flat/auth/useAuthContext'; // Added useAuthContext

const TopNav: React.FC = () => {
  const { signOut } = useAuth();
  const { userRole } = useAuthContext(); // Get userRole
  console.log("[TopNav] User Role:", userRole); // Add console log for debugging
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
  const closeDropdown = () => setIsDropdownOpen(false);

  return (
    <nav className="bg-white shadow-sm fixed top-0 left-0 right-0 h-16 z-20 flex items-center justify-between px-4 md:px-8">
      {/* Left side - Logo and App Title */}
      <div className="flex items-center">
        <Link to="/" className="flex items-center space-x-2">
          <img src={recurringValuePodcastLogoUrl} alt="Podcast Logo" className="h-8 w-auto" /> 
          {/* You can add a title next to the logo if needed */}
          {/* <span className="text-lg font-semibold text-gray-800">Admin</span> */}
        </Link>
      </div>

      {/* Right side - User menu */}
      <div className="relative">
        <div onClick={toggleDropdown} className="cursor-pointer flex items-center">
          <UserButton afterSignOutUrl="/" appearance={{
            elements: {
              userButtonAvatarBox: "w-10 h-10",
              userButtonPopoverCard: "hidden" // We will use our own dropdown
            }
          }} />
          <ChevronDown className="h-5 w-5 text-gray-500 ml-1" />
        </div>

        {isDropdownOpen && (
          <div
            className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg py-1 z-30 border border-gray-200"
            onMouseLeave={closeDropdown}
          >
            <Link
              to="/profile"
              onClick={closeDropdown}
              className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              <User className="h-4 w-4 mr-2" />
              Profile
            </Link>
            <Link
              to="/team"
              onClick={closeDropdown}
              className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              <Users className="h-4 w-4 mr-2" />
              Team Management
            </Link>

            {userRole === 'admin' && (
              <Link
                to="/settings"
                onClick={closeDropdown}
                className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                <SettingsIcon className="h-4 w-4 mr-2" />
                Site Settings
              </Link>
            )}

            <button
              onClick={() => {
                closeDropdown();
                signOut(() => window.location.replace('/'));
              }}
              className="w-full text-left flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              <LogOut className="h-4 w-4 mr-2" />
              Sign Out
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default TopNav; 